// extracted by mini-css-extract-plugin
module.exports = {"img":"image_img__1Fqi0","background":"image_background__Ge7Ru"};